import { render, staticRenderFns } from "./expenditure.vue?vue&type=template&id=b28453a6&"
import script from "./expenditure.vue?vue&type=script&lang=js&"
export * from "./expenditure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports